import { Form, Input, Row, Col, List, Button, Space, DatePicker } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import { RtnType } from '../../../utilsTs/declareTypes';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import SendAnEmail, { SendAnEmailDataType } from './SendAnEmail';

const WebEdit = (props: any) => {
    const [form] = Form.useForm();
    const { data } = props;
    const ref = useRef<any>(undefined);
    const [defaultService, setDefaultService] = useState<string>('');
    const [InitData, setInitData] = useState<any>();
    const [attachments, setAttachments] = useState<any[]>([]); // 附件列表
    const [sendAnEmailVisible, setSendAnEmailVisible] = useState<boolean>(false);
    const [sendAnEmailData, setSendAnEmailData] = useState<SendAnEmailDataType>();

    // 格式化文件大小
    const formatSize = (bytes: number) => {
        if (!bytes || bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    };

    // 判断是否可预览（图片、PDF 等）
    const canPreview = (contentType: string) =>
        contentType?.startsWith('image/') || contentType === 'application/pdf';

    useEffect(() => {
        if (!ref.current) return;
        let urlService = ref.current.defaultService;
        setDefaultService(urlService);
        setInitData(() => ref.current.initData);
        ref.current.row.then((res: any) => {
            if (res.success === true) {
                const { emailSupplierId, emailsAttachments } = res.data;
                setSendAnEmailData({
                    emailSupplierId
                })
                // 设置附件数据
                if (emailsAttachments) {
                    setAttachments(emailsAttachments);
                }
            }
        });
        // fetchApi.GET(currentService, {
        //     apiId: "customerServiceOperator",
        //     apiExtend: 'showList'
        // }).then(res => {
        //     if (res.success) {
        //         setCustomerServiceOperator(res.data);
        //     }
        // })
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    const p = async (id: string) => {
        let x: RtnType = { success: true, data: id };
        return x;
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'emails',
        serviceId: 'business',
        dateColumnName: ['receivedAt']
    };

    /**
     * 获取文件地址
     * @param record 
     * @param isDownload 是否是下载
     * @returns 
     */
    const getFile = (record: any, isDownload?: boolean) => {
        const { destination, fileName, smallImage, serverUrl } = record?.file;
        const filePath = serverUrl + "/" + destination + "/" +
            (isDownload === true ? fileName : (smallImage ? smallImage : fileName));
        return filePath;
    };

    return (
        <>
            {sendAnEmailVisible ? (<SendAnEmail
                data={sendAnEmailData}
                onClose={() => setSendAnEmailVisible(false)} />) : null}
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '查看') + '邮件'}
                open={true}
                okButtonProps={{ style: { display: "none" } }}
                cancelText='确定'
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={1220}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={4}>
                            <Form.Item label="id" name="id">
                                <Input readOnly={true} />
                            </Form.Item>
                        </Col>

                        <Col span={15}>
                            <Form.Item label="主题" name="subject">
                                <Input readOnly={true} />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item label="日期" name="receivedAt" >
                                <DatePicker disabled={true} format="YYYY-MM-DD HH:mm:ss" />
                            </Form.Item>
                        </Col>

                        <Col span={10}>
                            <Form.Item label="发件人" name="senderName">
                                <Input readOnly={true} />
                            </Form.Item>
                        </Col>

                        <Col span={11}>
                            <Form.Item label="收件人" name="recipientsEmail">
                                <Input readOnly={true} />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        const originalSender = form.getFieldValue('senderName') || '未知发件人';
                                        const originalDate = form.getFieldValue('receivedAt')
                                            ? new Date(form.getFieldValue('receivedAt')).toLocaleString()
                                            : '';
                                        const originalHtml = form.getFieldValue('bodyHtml') || '';
                                        // 构造引用风格 HTML
                                        const bodyHtml = `<p>在 ${originalDate}，${originalSender} 写道：</p>
                                        <blockquote style="border-left:2px solid #ccc; margin:10px 0; padding:0 0 0 14px; color:#555;">${originalHtml}</blockquote>`
                                        setSendAnEmailData(prev => ({
                                            ...prev!,
                                            recipientsEmail: form.getFieldValue('senderName'),
                                            subject: `回复：${form.getFieldValue('subject')}`,
                                            bodyHtml: `<br/><br/><br/><br/><br/><br/>${bodyHtml}`
                                        }));
                                        setSendAnEmailVisible(true);
                                    }}
                                >
                                    回复
                                </Button>
                                <Button type='dashed' onClick={() => {
                                    setSendAnEmailData(prev => ({
                                        ...prev!,
                                        recipientsEmail: undefined,
                                        subject: form.getFieldValue('subject'),
                                        bodyHtml: form.getFieldValue('bodyHtml')
                                    }));
                                    setSendAnEmailVisible(true);
                                }}>转发</Button>
                            </Space>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="html" name="bodyHtml">
                                {/* <div
                                    style={{ backgroundColor: '#e6e6e6', padding: '12px' }}
                                    dangerouslySetInnerHTML={{ __html: bodyHtml }}
                                /> */}
                                <WangeditorV5ForAntD
                                    id="htmlContentEditor"
                                    displayMode="preview"
                                    style={{ height: 500 }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="TEXT" name="bodyText">
                                <Input.TextArea readOnly={true} autoSize={{ minRows: 1, maxRows: 6 }} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="附件">
                                {attachments.length === 0 ? (
                                    <span>无附件</span>
                                ) : (
                                    <List
                                        dataSource={attachments}
                                        renderItem={(item: any) => (
                                            <List.Item
                                                actions={[
                                                    canPreview(item.contentType) && (
                                                        <Button
                                                            type="link"
                                                            onClick={() =>
                                                                window.open(`${getFile(item)}`, '_blank')
                                                            }
                                                        >
                                                            预览
                                                        </Button>
                                                    ),
                                                    <Button
                                                        type="link"
                                                        icon={<DownloadOutlined />}
                                                        onClick={() =>
                                                            window.open(`${getFile(item, true)}`, '_blank')
                                                        }
                                                    >
                                                        下载
                                                    </Button>,
                                                ]}
                                            >
                                                <span>
                                                    {item.filename}
                                                    <span style={{ color: '#999', marginLeft: 8 }}>
                                                        ({item.contentType} - {formatSize(item.size)})
                                                    </span>
                                                </span>
                                            </List.Item>
                                        )}
                                    />
                                )}
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    );
};

export default WebEdit;